
import React from 'react';
import { Scale, MessageCircle, Phone, Mail, Instagram, Facebook, Map, FileText, QrCode, Sparkles } from 'lucide-react';
import QRCodeGenerator from '../common/QRCodeGenerator';
import MapComponent from '../common/MapComponent';

const LegalLinktree = () => {
  const socialLinks = [
    { icon: Instagram, url: "https://www.instagram.com/decidedigitaloficial" },
    { icon: Facebook, url: "https://www.facebook.com/decidedigitaloficial" },
  ];

  const mainLinks = [
    {
      icon: Scale,
      title: "Áreas de Atuação",
      subtitle: "Conheça nossa especialidade",
      url: "https://decidedigital.com.br/"
    },
    {
      icon: FileText,
      title: "Consulta Jurídica",
      subtitle: "Agende sua consulta",
      url: "https://decidedigital.com.br/"
    },
    {
      icon: MessageCircle,
      title: "WhatsApp Jurídico",
      subtitle: "Atendimento especializado",
      url: "https://wa.me/5569992083972?text=Ol%C3%A1%20preciso%20de%20assessoria%20jur%C3%ADdica"
    },
    {
      icon: Phone,
      title: "Telefone",
      subtitle: "(69) 99208-3972",
      url: "tel:+5569992083972"
    },
    {
      icon: Mail,
      title: "E-mail Profissional",
      subtitle: "contato@decidedigital.com.br",
      url: "mailto:contato@decidedigital.com.br"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-100 to-gray-200 py-8 px-4">
      <div className="max-w-md mx-auto">
        {/* Profile Section */}
        <div className="bg-white rounded-2xl p-6 shadow-lg border-t-4 border-blue-600 mb-8 animate-fade-in">
          <div className="text-center">
            <div className="w-20 h-20 mx-auto mb-4 bg-gradient-to-br from-blue-600 to-blue-800 rounded-full flex items-center justify-center">
              <Scale className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Advocacia & Direito</h1>
            <h2 className="text-lg text-blue-700 font-medium mb-3">Dr. João Silva - OAB/RO 12345</h2>
            <div className="flex items-center justify-center gap-2">
              <Scale className="w-4 h-4 text-blue-600" />
              <p className="text-gray-600 text-sm leading-relaxed">
                Escritório especializado em Direito Civil, Trabalhista e Empresarial. 
                Mais de 15 anos defendendo seus direitos com excelência e ética.
              </p>
            </div>
          </div>
        </div>

        {/* QR Code Section */}
        <div className="bg-white rounded-xl p-4 shadow-md mb-6 text-center animate-scale-in">
          <div className="flex items-center justify-center gap-2 mb-3">
            <QrCode className="w-4 h-4 text-blue-600" />
            <p className="text-gray-700 text-sm">Acesse nosso site institucional:</p>
          </div>
          <div className="flex justify-center">
            <QRCodeGenerator url="https://decidedigital.com.br/" size={100} />
          </div>
        </div>

        {/* Social Icons */}
        <div className="flex justify-center space-x-4 mb-6">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-12 h-12 bg-blue-600 rounded-xl flex items-center justify-center hover:bg-blue-700 transition-all duration-300 hover:scale-110 animate-scale-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <social.icon className="w-5 h-5 text-white" />
            </a>
          ))}
        </div>

        {/* Main Links */}
        <div className="space-y-4">
          {mainLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full p-5 bg-white border-l-4 border-blue-600 rounded-xl hover:shadow-lg transition-all duration-300 transform hover:scale-105 animate-fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-center">
                <div className="w-12 h-12 bg-blue-50 rounded-xl flex items-center justify-center mr-4">
                  <link.icon className="w-6 h-6 text-blue-600" />
                </div>
                <div className="flex-1">
                  <div className="font-semibold text-gray-900">{link.title}</div>
                  <div className="text-sm text-gray-600">{link.subtitle}</div>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Office Location */}
        <div className="bg-white rounded-xl p-4 shadow-md mt-6 animate-fade-in">
          <div className="flex items-center justify-center gap-2 mb-3">
            <Map className="w-4 h-4 text-blue-600" />
            <p className="text-gray-700 text-sm font-medium">Localização do Escritório:</p>
          </div>
          <MapComponent latitude={-8.7619} longitude={-63.9019} zoom={17} />
        </div>

        {/* Trust Badge */}
        <div className="bg-blue-600 rounded-xl p-4 mt-4 text-white text-center animate-fade-in">
          <div className="flex items-center justify-center gap-2 mb-1">
            <Sparkles className="w-4 h-4" />
            <p className="font-semibold text-sm">Advocacia de Confiança</p>
          </div>
          <p className="text-xs opacity-90">Registrado na OAB - Sigilo Profissional Garantido</p>
        </div>
      </div>
    </div>
  );
};

export default LegalLinktree;
